export const getTags = (state) => state.tags
